import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../../i18n/i18n';
import Select from 'react-select';
import { Fab } from '@material-ui/core';
import AddInstitutions from './AddInstitutions';
import { wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import { Delete } from '../../../utils/Delete';

const CheckboxTable = checkboxHOC(ReactTable);;

export default class ViewInstitutions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            regionType: [], institutionType: [],
            showFilters: false, switchFlag: false, loading: false,
            page: 0, pageSize: 25, sorted: null, filtered: null,
            selection: [], selectAll: false, selectedRow: [],
            totalPages: 0, totalInstitutions: 0,
            add: false, edit: false, delete: false,
            data: [], user: [],
        };
        this.toggleSelection = this.toggleSelection.bind(this);
    }

    componentDidMount() {
        let user = this.getUser();
        this.setState({ user });
        // this.getByURL('region/filter_region', 'regionType');
        this.getByURL('institution/filter_institution', 'institutionType');
    }

    getUser() {
        let user = localStorage.getItem('user');
        let userObject = JSON.parse(user);
        !user && window.location.replace(window.location.origin);
        return userObject;
    }

    getData(url, state, instance) {
        this.setState({ loading: true, data: [] });
        let user = this.getUser();
        axios.get(`api/${url}`, {
            params: { page: state.page, pageSize: state.pageSize, sorted: state.sorted, filtered: state.filtered, region: user.id_region }
        })
            .then(res => {
                this.setState({
                    data: res.data.data,
                    totalPages: res.data.total_pages,
                    totalInstitutions: res.data.total,
                    loading: false
                });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getData): ', error);
            })
    }

    getByURL(url, obj) {
        axios.get(`api/${url}`)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 2 (getByURL): ', error, ', URL: ', url);
            })
    }


    isSelected = key => { return this.state.selection.includes(key); };
    onSearchClick = () => this.setState({ showFilters: !this.state.showFilters });
    onEditClick() { this.setState({ add: !this.state.add, edit: true }); }
    onTableClick = () => this.props.history.push('/institutions');

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
    };

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        }
        else selection.push(key);
        let selectedRow = null;
        if (selection.length == 1) selectedRow = this.state.data.filter((el) => el.id == selection)[0];
        this.setState({ selection, selectedRow });
    };

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false, selectedRow: [] });
        }
        else if (this.state.selection.length > 0 && this.state.add == false && this.state.edit == false) {
            this.setState({ selectedRow: [] });
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add === false) this.getData('institution/read_institution', this.state);
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    selectAll: false,
                })
            }
        });
    };

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        axios.post(`api/institution/delete`, { selection: this.state.selection })
            .then(res => {
                this.getData('institution/read_institution', this.state);
                this.setState({ delete: false });
            })
            .catch(err => {
                this.setState({ delete: false });
                console.log('Error: ', err);
            })
    }

    render() {


        // let regionType = this.state.regionType.map((item) => { return { label: item.naziv, value: item.id } });
        let instType = this.state.institutionType.filter(item => item.id_region === this.state.user.id_region);
        let institutionType = instType.map((item) => { return { label: item.naziv, value: item.id } });
        console.log(institutionType)


        const columns = [
            { Header: i18n.t('ID'), accessor: 'id' },
            { Header: i18n.t('Naziv'), accessor: 'naziv' },
            { Header: i18n.t('Vrsta institucije'), accessor: 'naziv_vrste_institucije', Filter: ({ filter, onChange }) => <FilterSelect onChange={onChange} type={institutionType} /> },
            // { Header: i18n.t('Region'), accessor: 'naziv_regiona', Filter: ({ filter, onChange }) => <FilterSelect onChange={onChange} type={regionType} /> },
            { Header: i18n.t('Opstina'), accessor: 'naziv_opstine' },
            { id: 'aktivan', Header: i18n.t('Aktivan'), accessor: d => d.aktivan, Cell: ({ value }) => value != 0 ? i18n.t('Yes') : i18n.t('No') },
            { id: 'apliciranje', Header: i18n.t('Apliciranje'), accessor: d => d.apliciranje, Cell: ({ value }) => value != 0 ? i18n.t('Yes') : i18n.t('No') },
            { Header: i18n.t('Opis'), accessor: 'opis' },
            { Header: i18n.t('Institution Web link'), accessor: 'web_link', Cell: ({ value }) => <a href={value} target="_blank">{value}</a> },
        ];

        const url = 'institution/read_institution';

        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll, isSelected, toggleSelection, toggleAll, selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return { style: { backgroundColor: selected ? "#ACDAF1" : "inherit" } };
                }
                return {};
            }
        };

        return (
            <div className="page">
                <div className="table-header">
                    <Fab onClick={() => this.onSearchClick()}
                        color="secondary"
                        aria-label="add"
                        className="action-button">
                        <span className="icon-search headerIcon" />
                    </Fab>
                    <Fab onClick={() => this.handleClick()}
                        color="secondary"
                        aria-label="add"
                        className="action-button">
                        <span className="icon-Plus headerIcon" />
                    </Fab>
                    {this.state.selection.length === 1 ?
                        <Fab onClick={() => this.onEditClick()}
                            color="secondary"
                            aria-label="edit"
                            className="action-button">
                            <span className="icon-Izmeni1 headerIcon" />
                        </Fab>
                        : null
                    }
                    {this.state.selection.length > 0 ?
                        <Fab onClick={() => this.onDeleteClick()}
                            color="secondary"
                            aria-label="add"
                            className="action-button">
                            <span className="icon-Kanta headerIcon" />
                        </Fab>
                        : null
                    }
                </div>
                <CheckboxTable ref={r => (this.checkboxTable = r)}
                    manual
                    data={this.state.data}
                    paging={true}
                    columns={columns}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.state.totalPages}
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => { this.getData(url, state, instance); }}
                    loading={this.state.loading}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF',
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                />
                {this.state.add && <AddInstitutions add={this.state.add} edit={this.state.edit} handleClose={this.handleClick} data={this.state.selectedRow} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />}

            </div>
        )
    }
};

function FilterSelect(props) {
    return <Select
        isMulti
        name="naziv"
        onChange={value => { props.onChange(value) }}
        closeMenuOnSelect={false}
        options={props.type}
        className="multi-select-in-filter"
        classNamePrefix="select"
        placeholder={i18n.t('Select')}
    />
}